import React, { Component } from 'react';
import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import server from '../../../api/server'; // Import the server instance

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faSyncAlt, faServer, faHashtag, faSearch, faTimes, faSpinner, faChevronDown, faPlus } from '@fortawesome/free-solid-svg-icons';

import { PERMISSIONS, CHANNEL_PERMISSIONS } from "../../../variables";
import RefreshBotData from './RefreshBotData';

export class RoleAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDropDown: false,
            search_term: "",
            items: [],
            addedItems: [],
            selectionMode: 'default', // default, guildSelect, idInput, guild
            selectedGuildId: null,
            idToAdd: '',
            guildsList: [],
            guildsLoading: false,
            guildsError: null,
            hasMoreGuilds: true, // Added for pagination
            guildsLoadingMore: false, // Added for pagination
            guildContentData: {}, // Store fetched data { roles: [], channels: [], members: [] }
            guildContentLoading: false,
            guildContentError: null,
        };
    }

    componentDidMount() {
        document.addEventListener("click", this.handleClick, true);
        if (this.props.type == "permissions") {
            this.setState({ items: PERMISSIONS });
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClick, true);
    }

    handleClick = (event) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                showDropDown: false,
                selectionMode: 'default',
                selectedGuildId: null,
                idToAdd: ''
            });
        }
    };

    addItem = (item) => {
        const addedItems = [...this.props.items];
        // Check if exists;
        if (this.props.type == "permissions") {
            if (addedItems.includes(item)) return;
        } else {
            if (addedItems.find((i) => i.id == item.id)) return;
        }
        addedItems.push(item);
        // console.log('RoleAdd: Calling props.update with items:', addedItems, 'for option:', this.props.option); // DEBUG LINE REMOVED
        this.props.update(addedItems, this.props.option);
    };

    addItemById = () => {
        const idToAdd = this.state.idToAdd.trim();
        if (!idToAdd) return;

        let itemToAdd;
        const generatedNameBase = `ID: ${idToAdd}`;

        // Determine the type, defaulting to 'roles' if not provided or invalid for ID add
        const itemType = this.props.type === "channels" || this.props.type === "members" ? this.props.type : "roles";

        // Ensure item structure is consistent (at least id and name)
        if (itemType === "roles") {
            itemToAdd = {
                id: idToAdd,
                name: `Role (${generatedNameBase})`,
                type: this.props.channelFilter && this.props.channelFilter.length > 0 ? this.props.channelFilter[0] : 0
            };
        } else if (itemType === "members") {
            itemToAdd = {
                id: idToAdd,
                name: `User (${generatedNameBase})`
            };
        }

        const currentItems = this.props.items || [];
        // Check if item with this ID already exists
        if (currentItems.some(item => item && item.id === itemToAdd.id)) {
            console.log("RoleAdd Info: Item with ID", itemToAdd.id, "already exists.");
            // Optionally: Add user feedback here (e.g., flash a message)
            this.setState({ // Still close dropdown even if duplicate
                showDropDown: false,
                selectionMode: 'default',
                idToAdd: ''
            });
            return;
        }

        // Construct the new items array and call update directly
        const updatedItems = [...currentItems, itemToAdd];
        console.log('RoleAdd (addItemById): Calling props.update with items:', updatedItems, 'for option:', this.props.option); // Specific DEBUG for AddByID
        this.props.update(updatedItems, this.props.option);

        // Reset state after updating
        this.setState({
            showDropDown: false,
            selectionMode: 'default',
            idToAdd: ''
        });
    };

    addSlashCommandOption = (item) => {
        const addedItems = [...this.props.items];
        addedItems.push({
            variable: item.name,
            name: item.name
        });
        this.props.update(addedItems, this.props.option);
    };

    selectGuild = (guildId) => {
        this.setState({
            selectionMode: 'guildSelect',
            selectedGuildId: guildId,
            guildContentLoading: false, // Reset loading states
            guildContentError: null,
            guildContentData: {}, // Clear previous data
            search_term: '' // Reset search term
        }, () => {
            // Fetch content for the newly selected guild
            this.fetchGuildContent(guildId);
        });
    };

    switchToIdInput = () => {
        this.setState({
            selectionMode: 'idInput',
            selectedGuildId: null
        });
    };

    resetSelectionMode = () => {
        this.setState({
            selectionMode: 'default',
            selectedGuildId: null,
            idToAdd: ''
        });
    };

    // State transition handler for selecting "Select from Guild"
    switchToGuild = () => {
        console.log("RoleAdd: switchToGuild called"); // <<< Log 1
        this.setState({
            selectionMode: 'guild',
            selectedGuildId: null,
            idToAdd: '',
            search_term: '',
            hasMoreGuilds: true, // Reset pagination on switch
            guildsList: [], // Clear list on switch
        }, () => {
            console.log("RoleAdd: switchToGuild setState callback - Calling fetchGuilds"); // <<< Log 2
            // Only fetch if list is empty OR there was an error previously
            // if (this.state.guildsList.length === 0 || this.state.guildsError) {
            this.fetchGuilds(); // Fetch initial batch
            // }
        });
    };

    fetchGuilds = async () => {
        console.log("RoleAdd: fetchGuilds started. Bot ID:", this.props.bot?.id); // <<< Log 3
        if (!this.props.bot || !this.props.bot.id) {
            this.setState({ guildsError: "Bot information is missing.", guildsLoading: false });
            return;
        }

        this.setState({ guildsLoading: true, guildsError: null }); // Don't reset list here

        try {
            // Initial fetch, no 'after' parameter
            const response = await server.post("/dashboard/getGuilds", { id: this.props.bot.id });
            console.log("RoleAdd: fetchGuilds API response:", response.data); // <<< Log 4 (Success)

            if (response.data && response.data.success) {
                const newGuilds = response.data.guilds || [];
                const sortedGuilds = newGuilds.sort((a, b) =>
                    a.name.localeCompare(b.name)
                );
                this.setState({
                    guildsList: sortedGuilds,
                    guildsLoading: false,
                    hasMoreGuilds: newGuilds.length === 200, // Check if more might exist
                    guildsError: null // Clear previous error on success
                });
            } else {
                const errorMessage = response.data.reason ? `Failed to fetch servers: ${response.data.reason}` : "Failed to fetch servers.";
                this.setState({ guildsError: errorMessage, guildsLoading: false, hasMoreGuilds: false });
            }
        } catch (error) {
            console.error("RoleAdd: fetchGuilds API error:", error); // <<< Log 4 (Error)
            this.setState({ guildsError: "An error occurred while fetching servers.", guildsLoading: false, hasMoreGuilds: false });
        }
    };

    loadMoreGuilds = async () => {
        if (!this.state.hasMoreGuilds || this.state.guildsLoadingMore || this.state.guildsLoading || !this.props.bot?.id) {
            return; // Don't load if no more, already loading, initial load in progress, or no bot ID
        }

        console.log("RoleAdd: loadMoreGuilds started.");
        this.setState({ guildsLoadingMore: true, guildsError: null });

        const lastGuild = this.state.guildsList[this.state.guildsList.length - 1];
        if (!lastGuild) {
            this.setState({ guildsLoadingMore: false }); // Should not happen if hasMore is true, but safety check
            return;
        }

        try {
            const response = await server.post("/dashboard/getGuilds", {
                id: this.props.bot.id,
                after: lastGuild.id // Pass the last guild's ID
            });
            console.log("RoleAdd: loadMoreGuilds API response:", response.data);

            if (response.data && response.data.success) {
                const newGuilds = response.data.guilds || [];
                const sortedNewGuilds = newGuilds.sort((a, b) => a.name.localeCompare(b.name));
                this.setState(prevState => ({
                    guildsList: [...prevState.guildsList, ...sortedNewGuilds],
                    hasMoreGuilds: newGuilds.length === 200,
                    guildsLoadingMore: false
                }));
            } else {
                const errorMessage = response.data.reason ? `Failed to load more servers: ${response.data.reason}` : "Failed to load more servers.";
                this.setState({ guildsError: errorMessage, guildsLoadingMore: false, hasMoreGuilds: false });
            }
        } catch (error) {
            console.error("RoleAdd: loadMoreGuilds API error:", error);
            this.setState({ guildsError: "An error occurred loading more servers.", guildsLoadingMore: false, hasMoreGuilds: false });
        }
    };

    // Fetch specific content (roles/channels/members) for a selected guild
    fetchGuildContent = async (guildId) => {
        console.log("RoleAdd: fetchGuildContent called. Props type:", this.props.type, "Guild ID:", guildId); // <<< LOGGING
        if (!this.props.bot || !this.props.bot.id || !guildId) {
            this.setState({ guildContentError: "Missing bot or server information.", guildContentLoading: false });
            return;
        }

        // Determine data type based on component props, default to 'roles'
        const dataType = (this.props.type === "channels" || this.props.type === "members")
            ? this.props.type
            : "roles"; // Default to 'roles' if not channels or members

        this.setState({ guildContentLoading: true, guildContentError: null, guildContentData: {} });

        try {
            const response = await server.post("/dashboard/guildData", {
                id: this.props.bot.id, // Bot ID
                guildId: guildId,
                dataType: dataType
            });

            if (response.data && response.data.success) {
                this.setState({
                    guildContentData: { [dataType]: response.data.data || [] }, // Store data under its type key
                    guildContentLoading: false,
                    guildContentError: null
                });
            } else {
                const errorMessage = response.data.reason ? `Failed to load ${dataType}: ${response.data.reason}` : `Failed to load ${dataType}.`;
                this.setState({ guildContentError: errorMessage, guildContentLoading: false });
            }
        } catch (error) {
            console.error(`Error fetching ${dataType} for guild ${guildId}:`, error);
            this.setState({ guildContentError: `An error occurred while fetching ${dataType}.`, guildContentLoading: false });
        }
    };

    renderGuildList = () => {
        const { guildsLoading, guildsError, guildsList, search_term, hasMoreGuilds, guildsLoadingMore } = this.state;
        console.log("RoleAdd: renderGuildList state:", { guildsLoading, guildsError, guildsListLength: guildsList.length, hasMoreGuilds, guildsLoadingMore }); // <<< Log 5

        const renderGuildIcon = (guild) => {
            if (guild.icon) {
                return (
                    <img
                        src={`https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png?size=32`}
                        alt={`${guild.name} icon`}
                        className="w-6 h-6 rounded-full mr-2 flex-shrink-0"
                        onError={(e) => { e.target.src = ''; e.target.style.display = 'none'; /* Hide if image fails */ }}
                    />
                );
            } else {
                // Fallback: First letter in a circle
                const initial = guild.name ? guild.name.charAt(0).toUpperCase() : '?';
                return (
                    <div className="w-6 h-6 rounded-full mr-2 flex-shrink-0 bg-[#5865f2] flex items-center justify-center text-white text-xs font-bold">
                        {initial}
                    </div>
                );
            }
        };

        let listContent;
        if (guildsList.length === 0 && !guildsLoading) { // Show 'no guilds' only if not loading and list is empty
            listContent = (
                <div className="p-4 text-center text-[#b9bbbe]">
                    No servers found for this bot. Make sure it has joined some servers.
                </div>
            );
        } else {
            // Filter guilds based on search term
            const filteredGuilds = guildsList.filter(guild =>
                guild.name.toLowerCase().includes(search_term.toLowerCase()) ||
                guild.id.includes(search_term) // Also allow search by ID
            );

            listContent = (
                <div className="guild-items-list py-1 max-h-60 overflow-y-auto custom-scrollbar">
                    {filteredGuilds.length === 0 && search_term !== "" && (
                        <div className="p-2 mx-2 text-center text-[#b9bbbe]">No matching servers found.</div>
                    )}
                    {filteredGuilds.map((guild) => (
                        <div
                            key={guild.id}
                            className="p-2 mx-2 my-1 hover:bg-[#3a3d42] cursor-pointer flex items-center text-[#b9bbbe] rounded"
                            onClick={() => this.selectGuild(guild.id)}
                        >
                            {renderGuildIcon(guild)}
                            <span className="text-[#ffffff] truncate" title={`${guild.name} (${guild.id})`}>{guild.name}</span>
                        </div>
                    ))}
                </div>
            );
        }

        let errorContent = null;
        if (guildsError && !guildsLoading && !guildsLoadingMore) {
            errorContent = (
                <div className="p-4 text-center">
                    <span style={{ color: '#F87171' }}>Error: {guildsError}</span>
                    <button
                        onClick={this.fetchGuilds} // Retry initial fetch
                        className="ml-2 px-2 py-1 bg-[#5865f2] text-white text-xs rounded hover:bg-[#4752c4]"
                        type="button"
                    >
                        Retry
                    </button>
                </div>
            );
        }

        let loadMoreButton = null;
        if (!guildsLoading && hasMoreGuilds && !search_term) { // Only show Load More if not searching
            loadMoreButton = (
                <div className="p-3 border-t border-[#1a1c1f]">
                    <button
                        onClick={this.loadMoreGuilds}
                        disabled={guildsLoadingMore}
                        className="w-full px-4 py-2 bg-[#4f545c] hover:bg-[#5865f2] text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                        type="button"
                    >
                        {guildsLoadingMore ? (
                            <><FontAwesomeIcon icon={faSpinner} spin className="mr-2" /> Loading More...</>
                        ) : (
                            <><FontAwesomeIcon icon={faChevronDown} className="mr-2" /> Load More Servers</>
                        )}
                    </button>
                </div>
            );
        }

        return (
            <div className="guild-list-container flex flex-col h-full"> {/* Use flex column for structure */}
                <div className="flex items-center justify-between p-3 border-b border-[#1a1c1f]">
                    <h3 className="text-lg font-semibold text-[#ffffff]">Select a Server</h3>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="cursor-pointer text-[#b9bbbe] hover:text-white"
                        onClick={this.resetSelectionMode}
                    />
                </div>
                {/* Guild Search Input */}
                <div className="p-3 border-b border-[#1a1c1f]">
                    <input
                        type="text"
                        className="w-full bg-[#202225] border border-[#1a1c1f] rounded px-3 py-2 text-[#dcddde] placeholder-[#72767d] focus:outline-none focus:border-[#ff4444]"
                        placeholder="Search servers by name or ID..."
                        value={this.state.search_term}
                        onChange={(e) => this.setState({ search_term: e.target.value })}
                        disabled={guildsLoading && guildsList.length === 0} // Disable only during initial load
                    />
                </div>

                {/* Loading Indicator for Initial Load */}
                {guildsLoading && guildsList.length === 0 && (
                    <div className="p-4 text-center text-[#b9bbbe] flex items-center justify-center">
                        <FontAwesomeIcon icon={faSpinner} spin className="mr-2" /> Loading servers...
                    </div>
                )}

                {/* Error Message Area */}
                {errorContent}

                {/* Guild List Area - Make it scrollable and take remaining space */}
                {!guildsLoading && (
                    <div className="flex-grow overflow-hidden"> {/* Container for the list */}
                        {listContent}
                    </div>
                )}

                {/* Load More Button Area */}
                {loadMoreButton}
            </div>
        );
    };

    renderGuildContent = () => {
        console.log('[renderGuildContent] Props Type:', this.props.type); // <<< Add this line
        const { selectedGuildId, guildContentLoading, guildContentError, guildContentData, search_term } = this.state;
        const dataType = this.props.type === "roles" || this.props.type === "channels" || this.props.type === "members"
            ? this.props.type
            : "roles"; // <<< Note: We added a default here previously

        if (!selectedGuildId) return null;

        // Find the name of the selected guild from the previously fetched list
        const guildName = this.state.guildsList.find(g => g.id === selectedGuildId)?.name || selectedGuildId;
        const title = `${guildName} - ${dataType ? dataType.charAt(0).toUpperCase() + dataType.slice(1) : 'Items'}`;
        const searchPlaceholder = `Search ${dataType || 'items'}...`;

        let content;
        if (guildContentLoading) {
            content = <div className="p-4 text-center text-[#b9bbbe]"><FontAwesomeIcon icon={faSpinner} spin className="mr-2" /> Loading {dataType}...</div>;
        } else if (guildContentError) {
            content = (
                <div className="p-4 text-center">
                    <span style={{ color: '#F87171' }}>Error: {guildContentError}</span>
                    <button
                        onClick={() => this.fetchGuildContent(selectedGuildId)}
                        className="ml-2 px-2 py-1 bg-[#5865f2] text-white text-xs rounded hover:bg-[#4752c4]"
                        type="button"
                    >
                        Retry
                    </button>
                </div>
            );
        } else {
            console.log('[renderGuildContent] Check:', {
                dataType: dataType,
                hasData: !!guildContentData[dataType],
                dataLength: guildContentData[dataType] ? guildContentData[dataType].length : 'N/A',
                guildContentData: guildContentData
            });
            if (!guildContentData[dataType] || guildContentData[dataType].length === 0) {
                content = <div className="p-4 text-center text-[#b9bbbe]">No {dataType} found in this server.</div>;
            } else {
                // Filter items based on search term
                const itemsToRender = (guildContentData[dataType] || []).filter(item =>
                    item.name.toLowerCase().includes(search_term.toLowerCase())
                );

                // Apply channel type filter if necessary
                const finalItemsToRender = dataType === 'channels'
                    ? itemsToRender.filter(channel =>
                    ((this.props.channelFilter === undefined && (channel.type === 0 || channel.type === 4)) ||
                        (this.props.channelFilter && this.props.channelFilter.length > 0 && this.props.channelFilter.includes(channel.type)))
                    )
                    : itemsToRender;

                content = (
                    <div className="max-h-60 overflow-y-auto guild-items-list py-1">
                        {finalItemsToRender.length === 0 && (
                            <div className="p-2 mx-2 text-center text-[#b9bbbe]">No matching {dataType} found.</div>
                        )}
                        {finalItemsToRender.map((item, index) => (
                            <div
                                key={item.id || index} // Use item.id if available
                                className="p-2 mx-2 my-1 hover:bg-[#3a3d42] cursor-pointer flex items-center text-[#b9bbbe] rounded"
                                onClick={() => {
                                    this.addItem(item);
                                    // Reset state fully after adding item
                                    this.setState({
                                        showDropDown: false,
                                        search_term: "",
                                        selectionMode: 'default',
                                        selectedGuildId: null,
                                        guildContentData: {},
                                        guildContentError: null,
                                        guildContentLoading: false
                                    });
                                }}
                            >
                                {/* Add specific icons based on type */}
                                {dataType === 'channels' && <FontAwesomeIcon icon={faHashtag} className="mr-2 text-[#ffffff]" />}
                                {dataType === 'roles' &&
                                    <div className="w-3 h-3 rounded-sm mr-2 flex-shrink-0" style={{ backgroundColor: item.color ? `#${item.color.toString(16).padStart(6, '0')}` : '#99aab5' }}></div>
                                }
                                {dataType === 'members' && item.avatar &&
                                    <img src={`https://cdn.discordapp.com/avatars/${item.id}/${item.avatar}.png?size=32`} alt="avatar" className="w-5 h-5 rounded-full mr-2 flex-shrink-0" onError={(e) => { e.target.style.display = 'none'; }} />
                                }
                                {dataType === 'members' && !item.avatar &&
                                    <div className="w-5 h-5 rounded-full mr-2 flex-shrink-0 bg-[#5865f2] flex items-center justify-center text-white text-[10px] font-bold">?</div>
                                }
                                <span className="text-[#ffffff] truncate">{item.name}</span>
                            </div>
                        ))}
                    </div>
                );
            }
        }

        return (
            <div className="guild-content-container">
                <div className="flex items-center justify-between p-3 border-b border-[#1a1c1f]">
                    <h3 className="text-lg font-semibold text-[#ffffff] truncate" title={title}>{title}</h3>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="cursor-pointer text-[#b9bbbe] hover:text-white"
                        onClick={() => this.setState({ selectionMode: 'guild', search_term: '' })} // Go back to guild list, clear search
                    />
                </div>
                {/* Item Search Input */}
                <div className="p-3 border-b border-[#1a1c1f]">
                    <input
                        type="text"
                        className="w-full bg-[#202225] border border-[#1a1c1f] rounded px-3 py-2 text-[#dcddde] placeholder-[#72767d] focus:outline-none focus:border-[#ff4444]"
                        value={search_term}
                        onChange={(e) => { this.setState({ search_term: e.target.value }); }}
                        placeholder={searchPlaceholder}
                        disabled={guildContentLoading} // Disable while loading
                    />
                </div>
                {content}
            </div>
        );
    };

    renderPermissionsContent = () => {
        let permissions = this.props.subType && this.props.subType === "channel" ? CHANNEL_PERMISSIONS : PERMISSIONS;

        return (
            <div className="permissions-container">
                <div className="flex items-center justify-between p-3 border-b border-[#1a1c1f]">
                    <h3 className="text-lg font-semibold text-[#ffffff]">Permissions</h3>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="cursor-pointer text-[#b9bbbe] hover:text-white"
                        onClick={this.resetSelectionMode}
                    />
                </div>
                <div className="p-3">
                    <input
                        type="text"
                        className="w-full bg-[#202225] border border-[#1a1c1f] rounded px-3 py-2 text-[#dcddde] placeholder-[#72767d] focus:outline-none focus:border-[#ff4444]"
                        value={this.state.search_term}
                        onChange={(e) => { this.setState({ search_term: e.target.value }); }}
                        placeholder="Search permissions"
                    />
                </div>
                <div className="max-h-60 overflow-y-auto">
                    {permissions.filter(permission =>
                        this.state.search_term === "" ||
                        permission.toLowerCase().includes(this.state.search_term.toLowerCase())
                    ).map((permission, index) => (
                        <div
                            key={index}
                            className="p-2 hover:bg-[#3a3d42] cursor-pointer text-[#b9bbbe] mx-2 rounded"
                            onClick={() => {
                                this.addItem(permission);
                                this.setState({ showDropDown: false, search_term: "", selectionMode: 'default' });
                            }}
                        >
                            <span className="text-[#ffffff]">{permission}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    renderChannelTypesContent = () => {
        const channelTypes = [
            { id: 0, name: "Text Channel" },
            { id: 1, name: "DM" },
            { id: 2, name: "Voice Channel" },
            { id: 3, name: "Group DM" },
            { id: 4, name: "Category" },
            { id: 5, name: "Announcement Channel" },
            { id: 10, name: "Announcement Thread" },
            { id: 11, name: "Public Thread" },
            { id: 12, name: "Private Thread" },
            { id: 13, name: "Stage Channel" },
            { id: 14, name: "Directory" },
            { id: 15, name: "Forum Channel" },
            { id: 16, name: "Media Channel" }
        ];

        return (
            <div className="channel-types-container">
                <div className="flex items-center justify-between p-3 border-b border-[#1a1c1f]">
                    <h3 className="text-lg font-semibold text-[#ffffff]">Channel Types</h3>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="cursor-pointer text-[#b9bbbe] hover:text-white"
                        onClick={this.resetSelectionMode}
                    />
                </div>
                <div className="p-3">
                    <input
                        type="text"
                        className="w-full bg-[#202225] border border-[#1a1c1f] rounded px-3 py-2 text-[#dcddde] placeholder-[#72767d] focus:outline-none focus:border-[#ff4444]"
                        value={this.state.search_term}
                        onChange={(e) => { this.setState({ search_term: e.target.value }); }}
                        placeholder="Search channel types"
                    />
                </div>
                <div className="max-h-60 overflow-y-auto">
                    {channelTypes.filter(type =>
                        this.state.search_term === "" ||
                        type.name.toLowerCase().includes(this.state.search_term.toLowerCase())
                    ).map((type, index) => (
                        <div
                            key={index}
                            className="p-2 hover:bg-[#3a3d42] cursor-pointer text-[#b9bbbe] mx-2 rounded"
                            onClick={() => {
                                this.addItem(type);
                                this.setState({ showDropDown: false, search_term: "", selectionMode: 'default' });
                            }}
                        >
                            <span className="text-[#ffffff]">{type.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    renderIdInput = () => {
        let placeholder = "Enter ID";
        let title = "Add by ID";

        if (this.props.type === "roles") {
            placeholder = "Enter role ID";
            title = "Add Role by ID";
        } else if (this.props.type === "channels") {
            placeholder = "Enter channel ID";
            title = "Add Channel by ID";
        } else if (this.props.type === "members") {
            placeholder = "Enter user ID";
            title = "Add User by ID";
        }

        return (
            <div className="id-input-container">
                <div className="flex items-center justify-between p-3 border-b border-[#1a1c1f]">
                    <h3 className="text-lg font-semibold text-[#ffffff]">{title}</h3>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="cursor-pointer text-[#b9bbbe] hover:text-white"
                        onClick={this.resetSelectionMode}
                    />
                </div>
                <div className="p-4 space-y-3">
                    <input
                        type="text"
                        className="w-full bg-[#202225] border border-[#1a1c1f] rounded px-3 py-2 text-[#dcddde] placeholder-[#72767d] focus:outline-none focus:border-[#ff4444]"
                        value={this.state.idToAdd}
                        onChange={(e) => { this.setState({ idToAdd: e.target.value }); }}
                        placeholder={placeholder}
                    />
                    <button
                        className="w-full px-4 py-2 bg-[#ff4444] hover:bg-[#ff6666] text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#ff4444] focus:ring-offset-2 focus:ring-offset-[#2f3136] disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={this.addItemById}
                        disabled={!this.state.idToAdd.trim()}
                        type="button"
                    >
                        Add
                    </button>
                </div>
            </div>
        );
    };

    renderDefaultOptions = () => {
        // Options depend on the type of selection
        let options = [];

        if (this.props.type === "permissions") {
            options.push(
                <div
                    key="permissions"
                    className="p-3 hover:bg-[#3a3d42] cursor-pointer rounded mx-2 my-1"
                    onClick={() => this.setState({ selectionMode: 'permissions' })}
                >
                    <div className="font-medium text-[#ffffff] mb-1">Select Permission</div>
                    <div className="text-sm text-[#b9bbbe]">Browse and select from available permissions</div>
                </div>
            );
        } else if (this.props.type === "channelTypes") {
            options.push(
                <div
                    key="channelTypes"
                    className="p-3 hover:bg-[#3a3d42] cursor-pointer rounded mx-2 my-1"
                    onClick={() => this.setState({ selectionMode: 'channelTypes' })}
                >
                    <div className="font-medium text-[#ffffff] mb-1">Select Channel Type</div>
                    <div className="text-sm text-[#b9bbbe]">Browse and select from available channel types</div>
                </div>
            );
        } else {
            // For roles, channels, members
            options.push(
                <div
                    key="selectFromGuild"
                    className="p-3 hover:bg-[#3a3d42] cursor-pointer rounded mx-2 my-1"
                    onClick={this.switchToGuild}
                >
                    <div className="font-medium text-[#ffffff] mb-1">Select from Server</div>
                    <div className="text-sm text-[#b9bbbe]">Choose a server first, then select options</div>
                </div>
            );

            options.push(
                <div
                    key="addById"
                    className="p-3 hover:bg-[#3a3d42] cursor-pointer border-t border-[#1a1c1f] mx-2 my-1 rounded"
                    onClick={this.switchToIdInput}
                >
                    <div className="font-medium text-[#ffffff] mb-1">Add by ID</div>
                    <div className="text-sm text-[#b9bbbe]">Directly enter an ID to add it</div>
                </div>
            );
        }

        // If there are slash command options
        if (this.props.slash === true && this.props.slash_options && this.props.slash_options.length > 0) {
            options.push(
                <div key="slashDivider" className="border-t border-[#1a1c1f] my-2 mx-2"></div>
            );

            options.push(
                <div key="slashHeader" className="px-3 py-1 text-xs font-semibold uppercase text-[#b9bbbe]">
                    Command Options
                </div>
            );

            this.props.slash_options.forEach((option, index) => {
                if (this.props.type === "roles" && option.type === "role") {
                    options.push(
                        <div
                            key={`slash_${index}`}
                            className="p-3 hover:bg-[#3a3d42] cursor-pointer rounded mx-2 my-1"
                            onClick={() => {
                                this.addSlashCommandOption(option);
                                this.setState({ showDropDown: false });
                            }}
                        >
                            <div className="font-medium text-[#ffffff]">{option.name}</div>
                        </div>
                    );
                }
                // Add similar blocks here if slash options are needed for channels/members
            });
        }

        return <div className="py-2">{options}</div>; // Add padding around the options list
    };

    renderDropDown = () => {
        if (!this.state.showDropDown) return null;

        let content;

        if (this.state.selectionMode === 'default') {
            content = this.renderDefaultOptions();
        } else if (this.state.selectionMode === 'guild') {
            content = this.renderGuildList();
        } else if (this.state.selectionMode === 'guildSelect') {
            content = this.renderGuildContent();
        } else if (this.state.selectionMode === 'idInput') {
            content = this.renderIdInput();
        } else if (this.state.selectionMode === 'permissions') {
            content = this.renderPermissionsContent();
        } else if (this.state.selectionMode === 'channelTypes') {
            content = this.renderChannelTypesContent();
        }

        return (
            <div className="role-adder-dropdown bg-[#2f3136] rounded-lg shadow-xl absolute z-50 border border-[#1a1c1f] flex flex-col" style={{
                top: "48px",
                left: "0",
                width: "320px",
                maxHeight: "450px",
                overflow: "hidden",
                padding: "4px 0"
            }}>
                {content}
            </div>
        );
    };

    renderItems = () => {
        // types :roles,permissions,channels,members
        const items = [];
        this.props.items.forEach((item, index) => {
            if (this.props.type === "permissions" || this.props.type === "words") {
                items.push(
                    <li className="role-adder-role flex items-center bg-[#424549] rounded-md px-2 py-1 mr-2 mb-2 text-[#dcddde] text-sm" key={index}>
                        <span className="mr-1">{item}</span>
                        <FontAwesomeIcon
                            onClick={() => { this.removeRole(index); }}
                            icon={faTimesCircle}
                            className="text-[#b9bbbe] hover:text-white cursor-pointer text-xs"
                        />
                    </li>
                );
            } else if (this.props.type === "channels") {
                if ((this.props.channelFilter === undefined && (item.type === 0 || item.type === 4)) ||
                    (this.props.channelFilter && this.props.channelFilter.length > 0 && this.props.channelFilter.includes(item.type))) {
                    items.push(
                        <li className="role-adder-role flex items-center bg-[#424549] rounded-md px-2 py-1 mr-2 mb-2 text-[#dcddde] text-sm" key={index}>
                            <span className="mr-1">#{item.name}</span>
                            <FontAwesomeIcon
                                onClick={() => { this.removeRole(index); }}
                                icon={faTimesCircle}
                                className="text-[#b9bbbe] hover:text-white cursor-pointer text-xs"
                            />
                        </li>
                    );
                }
            } else {
                if (item !== undefined) {
                    items.push(
                        <li className="role-adder-role flex items-center bg-[#424549] rounded-md px-2 py-1 mr-2 mb-2 text-[#dcddde] text-sm" key={index}>
                            <span className="mr-1">{item.name}</span>
                            <FontAwesomeIcon
                                onClick={() => { this.removeRole(index); }}
                                icon={faTimesCircle}
                                className="text-[#b9bbbe] hover:text-white cursor-pointer text-xs"
                            />
                        </li>
                    );
                }
            }
        });

        return items;
    };

    removeRole = (index) => {
        const addedItems = [...this.props.items];
        addedItems.splice(index, 1);
        this.props.update(addedItems, this.props.option);
    };

    render() {
        return (
            <div className={`role-adder relative ${this.props.commandSaveFailed === true ? "command-required" : ""}`}>
                {this.renderDropDown()}
                <ul className="flex flex-wrap items-center">
                    {this.renderItems()}
                    {this.props.dropdown !== false && (
                        <li>
                            <button
                                className="flex items-center justify-center w-8 h-8 rounded-md bg-[#424549] hover:bg-[#585b60] text-[#b9bbbe] hover:text-white transition-colors duration-200"
                                onClick={() => {
                                    if (this.props.disabled !== true) {
                                        this.setState({
                                            showDropDown: !this.state.showDropDown, // Toggle dropdown
                                            selectionMode: 'default' // Reset mode on open
                                        });
                                    } else {
                                        this.setState({ showDropDown: false });
                                    }
                                }}
                                disabled={this.props.disabled}
                                type="button"
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    bot: state.data.bot,
    bot_data: state.data.bot_data
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(RoleAdd);

// Add some basic scrollbar styling if needed
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #2f3136; /* Darker background for track */
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #4f545c; /* Slightly lighter thumb */
  border-radius: 4px;
  border: 2px solid #2f3136; /* Creates padding around thumb */
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #72767d; /* Lighter on hover */
}
`;
document.head.appendChild(styleSheet);
